import { AxiosResponse } from 'axios';

import { CreateSegmentType } from './types';

import { request } from 'api/axios';
import { Segment } from 'types/segment';

export const segmentService = {
  getSegments: () => {
    return request.get<void, AxiosResponse<Segment[]>>(`/segments`).then((res) => res.data);
  },
  createSegment: (body: CreateSegmentType) => {
    return request.post<void, AxiosResponse<Segment>>(`/segments`, body).then((res) => res.data);
  },
};
